import { Component, input } from '@angular/core'
import { NamedDate } from 'src/app/shared/models/namedDate'
import { MaskedDatePipe } from 'src/app/shared/pipes/maskedDate.pipe'

@Component({
  selector: '[app-date-display]',
  imports: [MaskedDatePipe],
  template: '{{ value() | maskedDate : namedDates() : format(): viewAsTZ() }}',
  styles: `
        :host {
            position: relative;
            display: block;
            margin-top: 0.5rem;
        }
    `,
})
export class DateDisplayComponent {
  value = input<Date | null>()
  format = input<string>()
  viewAsTZ = input<string>()
  namedDates = input<NamedDate[]>()
}